module.exports = __webpack_public_path__ + "static/img/activity_two.1a65fd53.jpg";